(()=>{'use strict';
function init(){
 const root=document.getElementById('cm109');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const allowed=/^(utm_(source|medium|campaign|term|content|id)|tw_source|tw_adid|fbclid|gclid|wbraid|gbraid|ttclid|campaign_id|adset_id|ad_id|placement|site_source_name)$/;
 const inbound=new URLSearchParams(location.search);
 root.querySelectorAll('[data-offer-link]').forEach(a=>{const target=new URL(a.getAttribute('href'),location.origin);for(const[k,v]of inbound)if(allowed.test(k))target.searchParams.set(k,v);a.href=target.href;});
 root.addEventListener('click',event=>{const link=event.target.closest('[data-scroll-offer],[data-offer-link]');if(!link)return;
  window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'chinology_lp_cta',lp:root.dataset.version,position:link.dataset.ctaPosition,label:link.textContent.trim()});
  if(link.hasAttribute('data-scroll-offer')){const target=root.querySelector(link.hash);if(target){event.preventDefault();target.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});}}
 });
 const bottom=root.querySelector('[data-bottom-bar]'),heroCta=root.querySelector('.cm-hero-cta');let scheduled=false;
 function updateBottom(){scheduled=false;const ctaRect=heroCta.getBoundingClientRect();const beforeOffer=[...root.querySelectorAll('[data-inline-cta],[data-buy-card]')].some(el=>{const r=el.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;});
  const drawer=document.querySelector('#mc-sidecart [data-ajax-cart-section]');const drawerOpen=drawer?.classList.contains('translate-x-0')||document.body.classList.contains('js-drawer-open');
  bottom.hidden=ctaRect.bottom>=0||beforeOffer||Boolean(drawerOpen);
  const mid=root.querySelector('#cm-offer-mid');bottom.querySelector('a').href=mid.getBoundingClientRect().bottom>0?'#cm-offer-mid':'#cm-offer';
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(updateBottom)}}
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);document.addEventListener('click',schedule);document.addEventListener('sidecart:open',()=>{bottom.hidden=true;setTimeout(schedule,200)});document.addEventListener('sidecart:close',schedule);new ResizeObserver(schedule).observe(root);updateBottom();
 const posterObserver=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){e.target.poster=e.target.dataset.poster;posterObserver.unobserve(e.target)}},{rootMargin:'600px'});root.querySelectorAll('video[data-poster]').forEach(v=>posterObserver.observe(v));
 const posterReady=Promise.all([document.fonts.ready,...[...root.querySelectorAll('.cm-video-poster')].map(img=>img.decode().catch(()=>{}))]);
 root.querySelectorAll('[data-video-frame]').forEach(frame=>{
  const video=frame.querySelector('[data-cm-video]');if(!video)return;let manualPause=false,inView=false,loaded=false;
  video.controls=false;video.muted=true;video.tabIndex=0;video.setAttribute('role','button');
  const reflect=()=>{video.setAttribute('aria-label',video.paused?'Play demonstration video':'Pause demonstration video');if(video.currentTime>0)frame.classList.add('is-playing')};
  async function play(){if(!loaded){if(video.hasAttribute('data-hero-video')){await posterReady;const poster=frame.querySelector('.cm-video-poster');video.poster=poster.currentSrc||poster.src;frame.classList.add('is-playing');await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));}if(!inView||manualPause)return;video.src=video.dataset.src;loaded=true;video.load();}video.play().catch(reflect);}
  const activate=()=>{if(video.paused){manualPause=false;inView=true;play()}else{manualPause=true;video.pause()}};
  video.addEventListener('click',activate);video.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();activate()}});
  video.addEventListener('play',reflect);video.addEventListener('pause',reflect);video.addEventListener('timeupdate',reflect);reflect();
  new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;if(!inView)video.pause();else if(!manualPause&&!reduced.matches&&!navigator.connection?.saveData&&!document.hidden)play()},{threshold:.3}).observe(video);
  reduced.addEventListener('change',()=>{if(reduced.matches)video.pause()});document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(inView&&!manualPause&&!reduced.matches&&!navigator.connection?.saveData)play()});
 });
 root.querySelectorAll('[data-carousel]').forEach(carousel=>{
  const track=carousel.querySelector('[data-carousel-track]'),slides=[...track.children],dots=[...carousel.querySelectorAll('[data-carousel-dot]')];if(!slides.length)return;
  let current=0,raf=false;
  const update=()=>{raf=false;current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));carousel.querySelector('[data-carousel-count]').textContent=(current+1)+' / '+slides.length;dots.forEach((d,i)=>{if(i===current)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};
  const go=i=>track.scrollTo({left:((i+slides.length)%slides.length)*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});
  carousel.querySelector('[data-carousel-prev]').addEventListener('click',()=>go(current-1));carousel.querySelector('[data-carousel-next]').addEventListener('click',()=>go(current+1));dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
  track.addEventListener('scroll',()=>{if(!raf){raf=true;requestAnimationFrame(update)}},{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1))}});
  new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'});update()}).observe(track);update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

/* cm109-meta-events-v1: page-local events for the existing Meta pixel. */
(() => {
  'use strict';
  const root = document.getElementById('cm109');
  if (!root || window.CM109MetaEventsV1 || window.Shopify?.designMode) return;
  window.CM109MetaEventsV1 = true;
  const pixel = '1924362164566100';
  const queue = [{name: 'ViewContent'}];
  const bound = new WeakSet();
  let initialized = false;

  function flush() {
    try { sendPending(); } catch (_) { /* Analytics must never interrupt an add. */ }
  }

  function sendPending() {
    if (window.Shopify?.customerPrivacy?.marketingAllowed?.() === false) return;
    let fbq = window.fbq;
    if (typeof fbq !== 'function') {
      fbq = window.fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    if (!initialized) {
      let exists = (fbq.queue || []).some(args => args[0] === 'init' && String(args[1]) === pixel);
      if (typeof fbq.getState === 'function') {
        exists = exists || (fbq.getState().pixels || []).some(item => String(item.id) === pixel);
      }
      if (!exists) fbq('init', pixel);
      initialized = true;
    }
    while (queue.length) {
      const event = queue[0];
      if (event.data) fbq('trackSingle', pixel, event.name, event.data);
      else fbq('trackSingle', pixel, event.name);
      queue.shift();
    }
  }

  function bind() {
    const api = window.liquidAjaxCart;
    if (!api || typeof api.subscribeToCartAjaxRequests !== 'function' || bound.has(api)) return;
    bound.add(api);
    api.subscribeToCartAjaxRequests((request, subscribe) => {
      const form = request.info?.initiator;
      if (request.requestType !== 'add' || !(form instanceof Element) ||
          !form.matches('[data-cm109-form]') || !root.contains(form)) return;
      let tracked = false;
      subscribe(result => {
        if (tracked || !result.responseData?.ok || result.info?.cancel) return;
        tracked = true;
        queue.push({name: 'AddToCart', data: {currency: 'USD'}});
        flush();
      });
    });
  }

  document.addEventListener('liquidAjaxCartInit', bind, true);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('visitorConsentCollected', flush);
  bind();
  flush();
})();
